import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MemoComponent } from '../memo/memo.component';
/**
 * Wrapper for Memo Component
 */
@Component({
  selector: 'app-memo-wrapper',
  templateUrl: './memo-wrapper.component.html',
  styleUrls: ['./memo-wrapper.component.scss']
})
export class MemoWrapperComponent implements OnInit, AfterViewInit {
  /**
   * modal data
   */
  data;

  /**
   * boolean indicator to indicate window is maximized or minimized
   */
  isMaximized = false;

  /**
   * Facility Id
   */
  facilityId;

  /**
   * Facility IdSeq
   */
  facilityIdSeq;

  /**
   * VFC Pin
   */
  vfcPin;

  /**
   * date of facilityCreated
   */
  facilityDateCreated;

  /**
   * Referemce of Manage Audit Component
   */
  @ViewChild(MemoComponent, {}) memoComponent: MemoComponent;

  /**
   * constructor to inject dependency
   * @param dialogRef instance of ngx bootstrap modal dialog service
   */
  constructor(private dialogRef: BsModalRef) {}

  /**
   * initialize component
   */
  ngOnInit(): void {
    this.facilityId = this.data?.facilityId;
    this.vfcPin = this.data?.vfcPin;
    this.facilityDateCreated = this.data?.dateCreated;

    // Set memo size to be non-fullscreen by default
    this.dialogRef.setClass('modal-dialog-centered modal-xl');
  }

  /**
   * Maximize or Minimize window
   */
  maximize() {
    this.isMaximized = !this.isMaximized;
    //const cssClass = this.isMaximized ? 'modal-dialog-centered modal-fullscreen' : 'modal-dialog-centered modal-xl';
    /** adding try catch for unit test, Unit test is failing */
    /*try {
      this.dialogRef.setClass(cssClass);
    } catch (e) {}*/
  }

  /**
   * Close window
   * @param value value to be returned
   */
  close(value?) {
    this.dialogRef.hide();
  }

  /**
   * after the view is initialized
   */
  ngAfterViewInit() {
    if (this.memoComponent && typeof this.memoComponent.initComponent === 'function') {
      this.memoComponent.initComponent();
    }
  }
}
